import Feature from '../helpers/feature';
import ScoreBasedRecaptcha from 'recaptcha-web-client/ScoreBasedRecaptcha';
import RecaptchaTracking from 'recaptcha/RecaptchaTracking';
import { RECAPTCHA } from '../helpers/featureConstants';
import { FLOW_TYPE, PARTNER_USING_RECAPTCHA } from '../models/FlowModel';

export const RECAPTCHA_FORMS = Object.freeze({
    FORM_SIGN_IN: 'FORM_SIGN_IN',
    FORM_SIGN_UP: 'FORM_SIGN_UP',
    FORM_PARTNER_SIGN_IN: 'FORM_PARTNER_SIGN_IN',
    FORM_PARTNER_SIGN_UP: 'FORM_PARTNER_SIGN_UP',
    FORM_RENDEZVOUS_SIGN_IN: 'FORM_RENDEZVOUS_SIGN_IN',
    FORM_RENDEZVOUS_SIGN_UP: 'FORM_RENDEZVOUS_SIGN_UP',
    FORM_PAYMENT: 'FORM_PAYMENT',
    FORM_EDIT_PAYMENT: 'FORM_EDIT_PAYMENT',
    FORM_SWITCH_PLAN: 'FORM_SWITCH_PLAN',
    FORM_CHANGE_EMAIL: 'FORM_CHANGE_EMAIL',
    FORM_CHANGE_PASSWORD: 'FORM_CHANGE_PASSWORD',
    FORM_EDU: 'FORM_EDU',
});

export default class Recaptcha {
    static isPartnerFormAction(recaptchaAction = '') {
        return (
            recaptchaAction === RECAPTCHA_FORMS.FORM_PARTNER_SIGN_IN ||
            recaptchaAction === RECAPTCHA_FORMS.FORM_PARTNER_SIGN_UP
        );
    }

    static async mutateRequestData({ httpData = {}, recaptchaAction = '', recaptchaPartner = '' }) {
        // override recaptchaPartner for generic OAuth
        recaptchaPartner =
            recaptchaPartner === FLOW_TYPE.DEFAULT
                ? PARTNER_USING_RECAPTCHA.PPLUS
                : recaptchaPartner;

        const recaptchaFeatureFlag = Feature.isActive(RECAPTCHA);
        const formFeatureFlag = Feature.isActive(RECAPTCHA + '_' + recaptchaAction.toLowerCase());
        const partnerFeatureFlag = Feature.isActive(
            RECAPTCHA + '_partner_' + recaptchaPartner.toLowerCase(),
        );

        // required params
        httpData.recaptchaAction = recaptchaAction;
        httpData.recaptchaPartner = recaptchaPartner;

        // only append recaptcha token if FFs enabled
        if (recaptchaFeatureFlag && formFeatureFlag) {
            if (
                !Recaptcha.isPartnerFormAction(recaptchaAction) ||
                (Recaptcha.isPartnerFormAction(recaptchaAction) && partnerFeatureFlag)
            ) {
                await this.appendRecaptchaToken(httpData);
            }
        }
    }

    /**
     * Fetch and append recaptcha token to the data object
     *
     * @param data
     */
    static async appendRecaptchaToken(data) {
        // check if recaptcha is enabled in cms for the given data.recaptchaAction
        // if so get the recaptcha token and append it to data.recaptchaToken

        const recaptchaConfig = {
            siteKey: CBS?.Registry?.Recaptcha?.siteKey ?? 'recaptchaPublicKey-not-found',
            action: data?.recaptchaAction,
            trackingService: new RecaptchaTracking(),
        };
        const recaptchaClient = new ScoreBasedRecaptcha(recaptchaConfig);
        data.recaptchaToken = await recaptchaClient.getToken();

        const urlParams = new URLSearchParams(window.location.search);
        const debug = urlParams.get('RECAPTCHA_DEBUG');

        if (debug === 'true') {
            data.recaptchaDebug = true;
        }
    }

    /**
     * Track recaptcha trackRecaptchaFailure or trackCaptchaVerified from api response
     *
     * @param response
     */
    static trackRecaptchaTokenValidationResult(response) {
        const tokenValidated =
            response?.data?.recaptchaTokenValidated ?? response?.recaptchaTokenValidated;
        if (tokenValidated) {
            new RecaptchaTracking().verified();
        } else if (tokenValidated === false) {
            new RecaptchaTracking().failure();
        }
    }
}
